import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app.js";
import { applyTheme, readStoredTheme } from "./lib/theme.js";
import { installRipple } from "./lib/ripple.js";
import { AppErrorBoundary } from "./components/error-boundary.js";
import "./styles.css";

// Тема применяется до первого рендера, чтобы не мигать дефолтной.
applyTheme(readStoredTheme());
installRipple();

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root not found");
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
